import axios from "axios";
import ErrorParser from '../error.parser';

const NetworksService = {
  networks: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/networks/networks",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  responsible_authorities: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/networks/responsible_authorities",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  timezones: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/networks/timezones",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  mediavalues: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/networks/mediavalues",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  organisationallevels: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/networks/organisationallevels",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/management/networks/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  update: async function (network) {
    const requestData = {
      method: "post",
      url: "/api/management/networks/update",
      data: network
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  import: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/networks",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default NetworksService;
